import { render, staticRenderFns } from "./HelpCenterIcon.vue?vue&type=template&id=57ec7fa3"
import script from "./HelpCenterIcon.vue?vue&type=script&lang=js"
export * from "./HelpCenterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports